// extracted by mini-css-extract-plugin
module.exports = {"quick-fact":"quick-fact_quick-fact__JXDl_"};